// Nova returns profile sub-entities as Partials, so fields the profile
// components require (`id`, `title`) come back optional. Rows missing them
// can't be rendered or keyed anyway, so drop them rather than casting the
// type away. Remove this once nova's output types mark them required.
export const withRequiredFields = <T extends object, K extends keyof T>(
  items: T[],
  keys: K[],
): (T & Required<Pick<T, K>>)[] =>
  items.filter((item): item is T & Required<Pick<T, K>> =>
    keys.every((key) => item[key] !== undefined),
  );
